import { styles } from '@app/services/app-styles.service';

const togglebutton = {
    root: {
        borderRadius: styles().borderRadiusInput,
        borderColor: styles().primaryBackground,
        background: styles().primaryBackground,
    },
    checked: {
        background: styles().primaryBackground,
        borderColor: styles().primaryBackground,
    },
    hover: {
        background: styles().primaryBackground,
    },
};

export default togglebutton;
